/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MethodInfo from './MethodInfo';

/**
 * The ModelMetadataBooleanFunc model module.
 * @module model/ModelMetadataBooleanFunc
 * @version V1
 */
class ModelMetadataBooleanFunc {
    /**
     * Constructs a new <code>ModelMetadataBooleanFunc</code>.
     * @alias module:model/ModelMetadataBooleanFunc
     */
    constructor() { 
        
        ModelMetadataBooleanFunc.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ModelMetadataBooleanFunc</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ModelMetadataBooleanFunc} obj Optional instance to populate.
     * @return {module:model/ModelMetadataBooleanFunc} The populated <code>ModelMetadataBooleanFunc</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ModelMetadataBooleanFunc();

            if (data.hasOwnProperty('target')) {
                obj['target'] = ApiClient.convertToType(data['target'], Object);
            }
            if (data.hasOwnProperty('method')) {
                obj['method'] = MethodInfo.constructFromObject(data['method']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ModelMetadataBooleanFunc</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ModelMetadataBooleanFunc</code>.
     */
    static validateJSON(data) {
        // validate the optional field `method`
        if (data['method']) { // data not null
          MethodInfo.validateJSON(data['method']);
        }

        return true;
    }


}



/**
 * @member {Object} target
 */
ModelMetadataBooleanFunc.prototype['target'] = undefined;

/**
 * @member {module:model/MethodInfo} method
 */
ModelMetadataBooleanFunc.prototype['method'] = undefined;






export default ModelMetadataBooleanFunc;

